// extracted by mini-css-extract-plugin
module.exports = {"ErrorPage":"ErrorPage_ErrorPage__2MLcx","Title":"ErrorPage_Title__2AG_6","Link":"ErrorPage_Link__2_vSJ"};